module.exports = __webpack_public_path__ + "img/rocket.d811a1ba.svg";